import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";

import Formatter from "/src/lib/formatter";
import { simplifyGeoJSON } from "/src/lib/geojson/simplify.js";

const getEventDate = (data) => {
  if (data.site_status === "Open for Tender") {
    if (data.tender_close_date && (new Date(data.tender_close_date) < new Date())) {
      data.site_status = "Tender Closed";
      // console.log("The target date has passed.");
    }
  }
  if (data.expected_tender_launch_date && !data.tender_close_date && !data.tender_award_date) {
    return {
      color: "0,128,0",
      date: data.expected_tender_launch_date,
      prefix: "Launching "
    };
  }
  switch (data.site_status) {
    case "Upcoming":
      return {
        color: "0,128,0",
      }
    case "Awarded":
      return {
        color: "255,0,0",
        date: data.tender_award_date
      };
    case "Completed":
      return {
        color: "255,255,255",
      }
    case "Tender Closed":
      return {
        color: "255,0,0",
        date: data.tender_close_date,
      }
    case "Available for Application":
      return {
        color: "255,165,0",
      }
    default:
      if (data.tender_close_date) {
        return {
          color: "255,165,0",
          date: data.tender_close_date,
          prefix: "Closing "
        };
      }
  }
}

function Component({ data, ...otherProps }) {

  const renderImage = () => {
    try {
      const { color } = getEventDate(data) || {};
      let geojson = JSON.parse(data.geojson);
      if (data.geojson.length > 2500) {
        geojson = simplifyGeoJSON(geojson, 0.0001);
      }
      const coordinates = geojson.coordinates[0].map(item => item.slice().reverse());
      const [latitude, longitude] = data.coordinates.split(',');
      let polygons = JSON.stringify(coordinates) + ":" + (color || "255,0,0");
      if (polygons.length > 2500) {
        polygons = "";
      }
      const url = `https://www.onemap.gov.sg/api/staticmap/getStaticImage?layerchosen=default&zoom=17&height=450&width=450&lat=${latitude}&lng=${longitude}&polygons=${polygons}`;
      return (
        <Card.Img variant="top" loading="lazy" src={url} />
      );
    }
    catch (e) {
      return null;
    }
  }

  const renderSiteStatus = () => {
    let status = [];
    if (data.site_status) {
      const { date, prefix="" } = getEventDate(data) || {};
      const extraRender = date && `(${prefix}${Formatter.date(date, "mmm yyyy")})`;
      const site_status_class = `site_status_${data.site_status?.toLowerCase()?.replace(/\s/g,'')}`;
      status.push(
        <div key="site_status" className={`tiny ${site_status_class}`}>{data.site_status} {extraRender}</div>
      );
    }
    if (status.length > 0) {
      return (
        <div className="d-flex flex-column gap-1">
          {status}
        </div>
      );
    }
  }

  const renderFields = () => {
    let fields = [];
    if (data.top_date) {
      fields.push({
        key: "top_date",
        label: "TOP",
        value: Formatter.date(data.top_date, "mmm yyyy"),
      });
    }
    else if (data.expected_top_year) {
      fields.push({
        key: "expected_top_year",
        label: "Expected TOP",
        value: data.expected_top_year,
      });
    }
    if (data.success_tender_price > 0) {
      if (data.success_tender_price_psf > 0) {
        fields.push({
          key: "success_tender_price",
          label: "Successful Tender Price ($)",
          value: <>{Formatter.money(data.success_tender_price, 0, '$')} <b>({Formatter.money(data.success_tender_price_psf, 0, '$')} psf)</b></>,
        });
      }
      else {
        fields.push({
          key: "success_tender_price",
          label: "Successful Tender Price ($)",
          value: <>{Formatter.money(data.success_tender_price, 0, '$')}</>,
        });
      }
    }
    if (data.developer) {
      fields.push({
        key: "developer",
        label: "Successful Tenderer",
        value: data.developer,
      });
    }
    if (data.site_sqm > 0) {
      fields.push({
        key: "site_sqm",
        label: <>{"Site Area (m"}<sup>2</sup>{")"}</>,
        value: Formatter.money(data.site_sqm),
      });
    }
    if (data.gfa_sqm > 0) {
      fields.push({
        key: "gfa_sqm",
        label: <>{"Gross Floor Area (m"}<sup>2</sup>{")"}</>,
        value: Formatter.money(data.gfa_sqm),
      });
    }
    if (data.site_use) {
      fields.push({
        key: "site_use",
        label: "Site Use",
        value: data.site_use,
      });
    }
    if (fields.length > 0) {
      return fields.map(item => {
        return (
          <div key={item.key} className="d-flex flex-column gap-0">
            <div className="tiny text-muted">{item.label}</div>
            <div className="small">{item.value}</div>
          </div>
        );
      });
    }
  }

  //xl={3} lg={4} md={4} sm={6} xs={6}
  return (
    <Card {...otherProps}>
      {renderImage()}
      <Card.Body className="d-flex flex-column gap-1">
        {renderSiteStatus()}
        <div className="d-flex flex-column gap-0">
          <div className="fw-bold">{data.programme}</div>
          <div className="fw-bold">{data.project_name || data.site_name}</div>
        </div>
        <div className="d-flex flex-column align-items-start gap-1">
          <Badge bg="light" className="rounded-0 border-0 text-dark fw-normal">{data.property_type}</Badge>
        </div>
        {renderFields()}
      </Card.Body>
    </Card>
  );

}

export default Component;
